module.exports = __webpack_public_path__ + "img/bancontact.e85b7ad.svg";